export { resetPassword } from './reset-password';
